module.exports = [
	{
		"fund_family_label": "Vanguard",
		"as_of": "202510",
		"fund_id": 194,
		"net_asset_sum": 10232336663532,
		"long_asset_sum": 10408388326540,
		"num_equity_funds": 103,
		"equity_fund_net_assets": 7439616493844,
		"equity_fund_long_assets": 7441787241829,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 43318772278,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 42418767293,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 535,
		"df_producer_asset_sum": 24785283870,
		"df_financier_count_sum": 397,
		"df_financier_asset_sum": 201060860582,
		"df_consumer_count_sum": 2018,
		"df_consumer_asset_sum": 647059000470,
		"df_all_count_sum": 2761,
		"df_all_asset_sum": 860054679676,
		"df_all_weight_total": 0.11557098472820901,
		"climate_asset_sum": 619173135739,
		"ff_all_asset_sum": 603242611360,
		"sri_climate_asset_sum": 333296128,
		"sri_with_most_climate_asset": 153886783,
		"name": "Vanguard",
		"fund_family_name": "Vanguard",
		"label": "Vanguard"
	},
	{
		"fund_family_label": "BlackRock/iShares",
		"as_of": "202510",
		"fund_id": 590,
		"net_asset_sum": 4279598161778,
		"long_asset_sum": 4453357009891,
		"num_equity_funds": 312,
		"equity_fund_net_assets": 2941324687735,
		"equity_fund_long_assets": 2954838934641,
		"num_e_sri": 33,
		"num_e_usf": 0,
		"sri_long_assets": 64264095230,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 56057560054,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 918,
		"df_producer_asset_sum": 12863286913,
		"df_financier_count_sum": 929,
		"df_financier_asset_sum": 87337473246,
		"df_consumer_count_sum": 3751,
		"df_consumer_asset_sum": 225062505887,
		"df_all_count_sum": 5257,
		"df_all_asset_sum": 319376017125,
		"df_all_weight_total": 0.10808576175872096,
		"climate_asset_sum": 255139027866,
		"ff_all_asset_sum": 248307404178,
		"sri_climate_asset_sum": 3678626294,
		"sri_with_most_climate_asset": 1122736453,
		"name": "BlackRock/iShares",
		"fund_family_name": "BlackRock/iShares",
		"label": "BlackRock/iShares"
	},
	{
		"fund_family_label": "American Funds/Capital Group",
		"as_of": "202510",
		"fund_id": 99,
		"net_asset_sum": 3061726492062,
		"long_asset_sum": 3079396232650,
		"num_equity_funds": 38,
		"equity_fund_net_assets": 2287400516837,
		"equity_fund_long_assets": 2291760199520,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 69,
		"df_producer_asset_sum": 10009587176,
		"df_financier_count_sum": 152,
		"df_financier_asset_sum": 56168212439,
		"df_consumer_count_sum": 413,
		"df_consumer_asset_sum": 139558358695,
		"df_all_count_sum": 613,
		"df_all_asset_sum": 203308315543,
		"df_all_weight_total": 0.08871273512193034,
		"climate_asset_sum": 158820857004,
		"ff_all_asset_sum": 153010174482,
		"sri_climate_asset_sum": 0,
		"sri_with_most_climate_asset": 0,
		"name": "American Funds/Capital Group",
		"fund_family_name": "American Funds/Capital Group",
		"label": "American Funds/Capital Group"
	},
	{
		"fund_family_label": "Fidelity Investments",
		"as_of": "202510",
		"fund_id": 545,
		"net_asset_sum": 4402925230654,
		"long_asset_sum": 4502191200662,
		"num_equity_funds": 301,
		"equity_fund_net_assets": 3174502946302,
		"equity_fund_long_assets": 3194167180339,
		"num_e_sri": 21,
		"num_e_usf": 0,
		"sri_long_assets": 8878839519,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 7602359411,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 657,
		"df_producer_asset_sum": 7798959617,
		"df_financier_count_sum": 814,
		"df_financier_asset_sum": 69583292226,
		"df_consumer_count_sum": 3379,
		"df_consumer_asset_sum": 246990110370,
		"df_all_count_sum": 4610,
		"df_all_asset_sum": 321010065962,
		"df_all_weight_total": 0.1004988304738423,
		"climate_asset_sum": 233494714326,
		"ff_all_asset_sum": 229196498305,
		"sri_climate_asset_sum": 280504746,
		"sri_with_most_climate_asset": 118916318,
		"name": "Fidelity Investments",
		"fund_family_name": "Fidelity Investments",
		"label": "Fidelity Investments"
	},
	{
		"fund_family_label": "SPDR State Street Investment Management",
		"as_of": "202510",
		"fund_id": 171,
		"net_asset_sum": 1737746407211,
		"long_asset_sum": 1737791530758,
		"num_equity_funds": 94,
		"equity_fund_net_assets": 1416059950441,
		"equity_fund_long_assets": 1416064322919,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 1799298589,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 1786326293,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 365,
		"df_producer_asset_sum": 3974538411,
		"df_financier_count_sum": 299,
		"df_financier_asset_sum": 39555595452,
		"df_consumer_count_sum": 1347,
		"df_consumer_asset_sum": 135936498986,
		"df_all_count_sum": 1868,
		"df_all_asset_sum": 176828384830,
		"df_all_weight_total": 0.12487313038541592,
		"climate_asset_sum": 147050324243,
		"ff_all_asset_sum": 143628215630,
		"sri_climate_asset_sum": 99705092,
		"sri_with_most_climate_asset": 50552982,
		"name": "SPDR State Street Investment Management",
		"fund_family_name": "SPDR State Street Investment Management",
		"label": "SPDR State Street Investment Management"
	},
	{
		"fund_family_label": "Schwab Funds",
		"as_of": "202510",
		"fund_id": 95,
		"net_asset_sum": 727549536611,
		"long_asset_sum": 727584633945,
		"num_equity_funds": 43,
		"equity_fund_net_assets": 630258036020,
		"equity_fund_long_assets": 630263779424,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 217,
		"df_producer_asset_sum": 3631970390,
		"df_financier_count_sum": 177,
		"df_financier_asset_sum": 16001692669,
		"df_consumer_count_sum": 1047,
		"df_consumer_asset_sum": 58094547166,
		"df_all_count_sum": 1349,
		"df_all_asset_sum": 75644144594,
		"df_all_weight_total": 0.12001981878624124,
		"climate_asset_sum": 64309203793,
		"ff_all_asset_sum": 62152965769,
		"sri_climate_asset_sum": 0,
		"sri_with_most_climate_asset": 0,
		"name": "Schwab Funds",
		"fund_family_name": "Schwab Funds",
		"label": "Schwab Funds"
	},
	{
		"fund_family_label": "Dimensional Fund Advisors",
		"as_of": "202510",
		"fund_id": 145,
		"net_asset_sum": 702638067412,
		"long_asset_sum": 717303102796,
		"num_equity_funds": 79,
		"equity_fund_net_assets": 581168112290,
		"equity_fund_long_assets": 581354575632,
		"num_e_sri": 8,
		"num_e_usf": 0,
		"sri_long_assets": 18709891124,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 17039988163,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 1325,
		"df_producer_asset_sum": 3255965735,
		"df_financier_count_sum": 624,
		"df_financier_asset_sum": 15662695866,
		"df_consumer_count_sum": 2355,
		"df_consumer_asset_sum": 32817688408,
		"df_all_count_sum": 4009,
		"df_all_asset_sum": 50342291174,
		"df_all_weight_total": 0.08659481370602799,
		"climate_asset_sum": 56788819067,
		"ff_all_asset_sum": 54468570097,
		"sri_climate_asset_sum": 628919666,
		"sri_with_most_climate_asset": 225077018,
		"name": "Dimensional Fund Advisors",
		"fund_family_name": "Dimensional Fund Advisors",
		"label": "Dimensional Fund Advisors"
	},
	{
		"fund_family_label": "T. Rowe Price",
		"as_of": "202510",
		"fund_id": 184,
		"net_asset_sum": 948081562887,
		"long_asset_sum": 953150055339,
		"num_equity_funds": 81,
		"equity_fund_net_assets": 635759919899,
		"equity_fund_long_assets": 636555112093,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 26174729,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 26174729,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 101,
		"df_producer_asset_sum": 2278611682,
		"df_financier_count_sum": 207,
		"df_financier_asset_sum": 12167582115,
		"df_consumer_count_sum": 661,
		"df_consumer_asset_sum": 42211302609,
		"df_all_count_sum": 922,
		"df_all_asset_sum": 55946875669,
		"df_all_weight_total": 0.08789007362621923,
		"climate_asset_sum": 44648550616,
		"ff_all_asset_sum": 42719991260,
		"sri_climate_asset_sum": 849120,
		"sri_with_most_climate_asset": 849120,
		"name": "T. Rowe Price",
		"fund_family_name": "T. Rowe Price",
		"label": "T. Rowe Price"
	},
	{
		"fund_family_label": "Invesco",
		"as_of": "202510",
		"fund_id": 336,
		"net_asset_sum": 1116550048138,
		"long_asset_sum": 1139188423055,
		"num_equity_funds": 202,
		"equity_fund_net_assets": 885390167583,
		"equity_fund_long_assets": 889626689093,
		"num_e_sri": 14,
		"num_e_usf": 0,
		"sri_long_assets": 10497511128,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 7972255401,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 208,
		"df_producer_asset_sum": 1712613237,
		"df_financier_count_sum": 276,
		"df_financier_asset_sum": 9419433022,
		"df_consumer_count_sum": 1348,
		"df_consumer_asset_sum": 77180508533,
		"df_all_count_sum": 1722,
		"df_all_asset_sum": 87144100463,
		"df_all_weight_total": 0.09795580722948624,
		"climate_asset_sum": 56373157226,
		"ff_all_asset_sum": 54822679518,
		"sri_climate_asset_sum": 271156904,
		"sri_with_most_climate_asset": 146911861,
		"name": "Invesco",
		"fund_family_name": "Invesco",
		"label": "Invesco"
	},
	{
		"fund_family_label": "TIAA Investments/Nuveen",
		"as_of": "202510",
		"fund_id": 166,
		"net_asset_sum": 698882358043,
		"long_asset_sum": 700439704967,
		"num_equity_funds": 61,
		"equity_fund_net_assets": 455721299787,
		"equity_fund_long_assets": 455732403253,
		"num_e_sri": 15,
		"num_e_usf": 1,
		"sri_long_assets": 44930922068,
		"usf_long_assets": 13408311326,
		"equity_fund_sri_long_assets": 37538415646,
		"equity_fund_usf_long_assets": 6835048089,
		"sustainable_manager": 0,
		"df_producer_count_sum": 198,
		"df_producer_asset_sum": 1650869726,
		"df_financier_count_sum": 183,
		"df_financier_asset_sum": 13175677978,
		"df_consumer_count_sum": 805,
		"df_consumer_asset_sum": 42404493662,
		"df_all_count_sum": 1123,
		"df_all_asset_sum": 56666699231,
		"df_all_weight_total": 0.1243420455217038,
		"climate_asset_sum": 33431065132,
		"ff_all_asset_sum": 32821053766,
		"sri_climate_asset_sum": 1136494583,
		"sri_with_most_climate_asset": 448330050,
		"name": "TIAA Investments/Nuveen",
		"fund_family_name": "TIAA Investments/Nuveen",
		"label": "TIAA Investments/Nuveen"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FamilyFunds.json
// module id = 960
// module chunks = 0